import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import Result from "./Result";
import {
  parseSystemCPUUsage,
} from "./api.js";
import ActionsContext from "common/ActionsContext";
import useDebouncer from "common/hooks/debouncer";
import View from "common/View";

export const cpuUsageRetrieval = () =>
  ifCl.run("show system cpu").then(parseSystemCPUUsage).then( cpus => ({cpus}));


const Report = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);

  const doLoad = () => {
    setRequest(cpuUsageRetrieval());
  };
  const debounce = useDebouncer(500 /*ms*/);
  useEffect(() => doLoad() || actions.recv("do-load", () => debounce(doLoad)), []);

  return (
    <Request during={request}>
      {(response) => <Result {...response} />}
    </Request>
  );
};

const CPUStatus = () => (
  <View title="CPU Usage">
    <Report />
  </View>
);

export default CPUStatus;
